__turbopack_context__.v({
  "bodyComponentContainer": "radioselect-module-scss-module__Ja8uWa__bodyComponentContainer",
  "label": "radioselect-module-scss-module__Ja8uWa__label",
  "selectContainer": "radioselect-module-scss-module__Ja8uWa__selectContainer",
  "selected": "radioselect-module-scss-module__Ja8uWa__selected",
});
